<template>
  <div class="rightTableDiv">
    <search-form
      @setSearchCondition="setSearchCondition"
      @clearSearch="clearSearch"
      @openModel="openModel"
      class="searchFormDiv"></search-form>
    <a-table
      bordered
      class="assetTable"
      id="assetTable"
      :pagination="pagination"
      :rowKey="record => record.id"
      :columns="tableData.columns"
      :dataSource="tableData.data"
      :loading="tableData.loading"
      @change="handleTableChange"
      :scroll="{ y: scrollY }"
      :customRow="changeRow"
    >
      <template slot="action" slot-scope="text, record">
        <a @click="openModel('view', record)">查看</a>
        <a @click="openModel('edit', record)" v-if="$auth('warehouseManagement.edit')">
          <a-divider type="vertical"/>编辑
        </a>
        <a-popconfirm
          placement="topLeft"
          title="确定删除么?"
          @confirm="e => del(record)"
          v-if="$auth('warehouseManagement.del')"
        >
          <a-divider type="vertical"/>
          <a style="color: red">删除</a>
        </a-popconfirm>
      </template>
    </a-table>
    <detail-model ref="detailModel" @setSearchCondition="setSearchCondition" :subcompanyid="subcompanyid"></detail-model>
  </div>
</template>
<script>
import SearchForm from './searchForm'
import {
  getEquipmentTableData
} from '@/api/gasEquipmentLedger'
import { mapGetters } from 'vuex'
import { delWarehouses, getWarehousesList } from '@/api/warehouseManagement'
import DetailModel from '@/views/warehouseManagement/modules/detailModel.vue'
export default {
  name: 'TableData',
  components: {
    DetailModel,
    SearchForm
  },
  computed: {
    ...mapGetters(['subcompanyid'])
  },
  data () {
    return {
      searchValue: '',
      // 表格数据
      tableData: {
        columns: [
          {
            title: '仓库名称',
            dataIndex: 'name',
            align: 'center'
          },
          {
            title: '仓库描述',
            dataIndex: 'description',
            align: 'center'
          },
          {
            title: '所属公司',
            dataIndex: 'subcompanyname',
            align: 'center'
          },
          {
            title: '所属部门',
            dataIndex: 'departmentname',
            align: 'center'
          },
          {
            title: '库房管理员',
            dataIndex: 'custodianNames',
            align: 'center'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'action'
            },
            align: 'center',
            width: 155
          }
        ],
        data: [],
        statistics: {
          normalSum: 0,
          abnormalSum: 0,
          normalaAmount: 0
        },
        loading: false
      },
      tableCurrRowId: null,
      dataTabsModel: {},
      sortedInfo: null,
      scrollY: 0,
      toLeftWidth: 0,
      // 搜索条件
      searchModel: {},
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      selectedRowKeys: [],
      // 左侧树的搜索条件
      treeSearchModel: {},
      // 当前选中展开的数据
      currentlySelectedExpansionData: {},
      disabled: false
    }
  },
  created () {
  },
  mounted () {

  },
  watch: {
    subcompanyid (newValue) {
      delete this.treeSearchModel.subcompanyid
      delete this.treeSearchModel.departmentid
      delete this.searchModel.departmentid
      delete this.searchModel.subcompanyid
      if (newValue.id !== '') {
        if (newValue.id === '空' || newValue.id === '杭氧') {
          this.tableData.data = []
          this.pagination.total = 0
          this.tableData.loading = false
          const dom = document.getElementsByClassName('ant-table-body')[0]
          dom.classList.add('ant-table-body-max-height-0')
        } else {
          if (newValue.type === 1) {
            this.treeSearchModel.subcompanyid = newValue.id
          } else {
            this.treeSearchModel.departmentid = newValue.id
          }
        }
        if (newValue.id !== '空') {
          this.setSearchCondition(this.searchModel)
        }
      } else {
        this.tableData.data = []
        this.pagination.total = 0
        this.tableData.loading = false
        const dom = document.getElementsByClassName('ant-table-body')[0]
        dom.classList.add('ant-table-body-max-height-0')
      }
    }
  },
  methods: {
    // 修改表格数据
    formateData (data) {
      const childrenArr = []
      data.forEach(item => {
        item.showIndex = false
        if (item.children) {
          item.marginRight = true
          this.formateData(item.children)
        } else {
          item.marginLeft = true
        }
        childrenArr.push(item)
      })
      return childrenArr
    },
    // 获取表格数据
    getTableData () {
      this.tableData.loading = true
      const { pageNum, pageSize } = this.pagination
      this.searchModel = { ...this.searchModel, pageNum, pageSize }
      this.selectedRowKeys = []
      const params = { ...this.searchModel }
      getWarehousesList(params).then(res => {
        if (res.status === 0) {
          this.tableData.data = res.data.list
          this.pagination.total = res.data.total
          this.tableData.loading = false
        } else {
          this.tableData.data = []
          this.tableData.total = 0
          this.tableData.loading = false
          this.$message.error(res.info.message)
        }
      })
    },
    // 搜索
    setSearchCondition (searchModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...searchModel }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      if (this.treeSearchModel.id === '000000') {
        delete this.searchModel.id
      }
      this.getTableData(true)
    },
    // 重置
    clearSearch (searchModel) {
      this.sort = {}
      this.sortedInfo = null
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      delete this.searchModel.id
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      if (this.treeSearchModel.id === '000000') {
        delete this.searchModel.id
      }
      this.getTableData(true)
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      delete this.searchModel.id
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      if (this.treeSearchModel.id === '000000') {
        delete this.searchModel.id
      }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      this.getTableData(true)
    },
    // 行
    changeRow (record) {
      return {
        on: {
          contextmenu: (event) => {
            event.preventDefault()
            event.stopPropagation()
          },
          dblclick: (event) => { // 双击行,双击选中
          },
          click: (event) => { // 单击行,双击选中
          }
        }
      }
    },
    // 打开新增弹窗
    openModel (type, model) {
      this.$refs.detailModel.setType(type)
      this.$refs.detailModel.setTitle(type === 'add' ? '新增' : type === 'edit' ? '编辑' : '详情')
      if (type !== 'add') {
        this.$refs.detailModel.setModel(model)
      }
      this.$refs.detailModel.open(true)
    },
    // 删除
    del (record) {
      const data = {
        ids: record.id
      }
      delWarehouses(data).then(res => {
        if (res.status === 0) {
          this.$message.success('删除成功')
          this.setSearchCondition()
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-table-tbody .blue{
  background-color: #e6f7ff !important;
}
.rightTableDiv {
  height: 100%;
  /deep/.assetTable  {
    transition: height 300ms ease;
    height: calc(100% - 42px);
    >.ant-spin-nested-loading {
      height: 100%;
      >.ant-spin-container {
        height: calc(100% - 43px);
        .ant-table {
          height: 100%;
          .ant-table-content {
            height: 100%;
            .ant-table-scroll{
              height: 100%;
              .ant-table-body {
                transition: max-height 300ms ease;
                height: 100%;
              }
              >.ant-table-placeholder {
                position: absolute;
                background: none;
                border-top: none;
                border-bottom: none;
                border-radius: 0 0 4px 4px;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                height: 100px;
                .ant-empty-normal {
                  margin: 0 !important;
                }
              }
            }
          }
        }
        >.ant-table-pagination.ant-pagination {
          margin: 10px 0 0 0 !important;
        }
      }
    }
    .ant-table-pagination.ant-pagination {
      margin: 10px;
    }
  }
}
.listContent {
  .table {
    margin-top: 10px;
  }
}
.ant-table-row-collapsed::after {
  content: '+';
  color: #DDDDDD;
}
.ant-table-row-expanded::after {
  content: '-';
  color: #DDDDDD;
}
/deep/.ant-table-footer {
  padding: 0 !important;
  height: 40px;
  .footerDiv {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #E7F4FF;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    .footerDivOne ,.footerDivTwo ,.footerDivThree {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      color: #333333;
      span:first-child {
        //margin-right: 20px;
      }
    }
    .footerDivOne {
      border-right: 1px solid #DDDDDD;
    }
    .footerDivTwo {
      border-right: 1px solid #DDDDDD;
    }
  }
}
/deep/.ant-table-expanded-row{
  >td{
    padding: 0;
    .expand_row{
      display: flex;
      .expand_left{
        width: 80px;
        border-right: 1px solid #e8e8e8;
      }
      .expand_right{
        width: calc(100% - 80px);
        //padding: 0 10px 8px 10px;
      }
    }
  }
}
.assetTableHeight_126 {
  height: calc(100% - 126px) !important;
}
.assetNameTable {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
/deep/.ant-table-row {
  td {
    padding: 6px 10px !important;
    position: relative;
  }
  .ant-table-column-has-sorters:nth-child(3) {
  }
}
.table-icon {
  margin-right: 7px;
  color: #87909f;
  font-size: 12px;
  cursor: pointer;
}
.table-icon-down {
  color: #08409f;
}
.table-icon-right {
  color: #dddddd;
}
</style>
